/**
 * Page Top
 */

import React, { Component, Fragment } from 'react';
import { TextField, Grid, Container, Typography, Box, Link, Checkbox, FormControlLabel, CssBaseline, Button, Avatar, InputAdornment, Paper } from '@material-ui/core'
import logo from '../images/mobile-phone.png';
import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
    insidePaper: {
        marginTop: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    main: {
        marginTop: theme.spacing(7),
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            padding: theme.spacing(4)
        },
    }
}));
export default function PageTop() {

    const classes = useStyles();

    return (
        <Container component="main" maxWidth="xs" className={classes.main}>

                <CssBaseline />
                <Box maxWidth="xs" display="flex" alignItems="center" justifyContent="center" marginBottom="50px">
                    <img src={logo} alt="flyins" width="100" height="100" />
                    <Grid item xs={12} >
                        <Typography color='primary' style={{ fontSize: '4rem', paddingLeft: '25px', fontFamily: 'Carter One, cursive' }}>
                            Flyins
                    </Typography>
                    </Grid >
                </Box>
        </Container>
    );
}